export const DashboardRouteNames = {
  default: 'dashboard-v2',
  oldDashboard: 'dashboard',
  create: 'dashboard-create',
  custom: 'reporting-custom',
  reportCreate: 'reporting-custom-create',
  reportBuilder: 'reporting-custom-view-builder',
  reportSchedule: 'reporting-custom-schedule'

}
